import React, { Component } from 'react';
import PropTypes from 'prop-types';
import looppa from 'looppa';
import Swiper from 'swiper';
import classNames from 'classnames';

import Icon from 'components/icon';

class Slider extends Component {
    static defaultProps = {
        on: {},
        updateOnInteraction: false,
    };

    static propTypes = {
        config: PropTypes.object,
        children: PropTypes.array.isRequired,
        facet: PropTypes.string.isRequired,
        on: PropTypes.object.isRequired,
        useNativeScroll: PropTypes.bool,
        updateOnInteraction: PropTypes.bool,
    };

    componentDidMount() {
        requestAnimationFrame(() => {
            this.create(this.props);
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.useNativeScroll === nextProps.useNativeScroll) {
            return;
        }

        this.destroy();
        this.create(nextProps);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) {
            if (this.swiper) {
                this.swiper.update();
            }
        }
    }

    componentWillUnmount() {
        this.destroy();
    }

    create(props) {
        if (props.useNativeScroll === true) {
            return;
        }

        const { config, facet, children, on } = props; // eslint-disable-line
        this.swiper = new Swiper(this.refs.container, {
            ...config,
            // remap the on events in order to receive always the swiper instance as first argument
            on: Object.keys(on).reduce((acc, key) => {
                acc[key] = () => this.swiper && on[key](this.swiper);
                return acc;
            }, {}),
        });

        setTimeout(() => {
            // mitigate the issue on sentry
            if (!this.swiper || !this.swiper.initialized) {
                return;
            }

            this.swiper.update();
        }, 200);
    }

    destroy() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            delete this.swiper;
        }
    }

    get isCardSlider() {
        return this.props.facet === 'card-overlay-slider';
    }

    renderNavigationArrows() {
        const { useNativeScroll } = this.props;

        return [
            <div ref="prevButton"
                className={ classNames('swiper-button-prev', useNativeScroll ? 'swiper-button__nativescroll' : null) }
                onClick={ () => (this.props.updateOnInteraction ? this.swiper.update() : null) }
                key='prev'>
                <Icon symbol="productslider-left" size={ this.isCardSlider ? 'large' : 'medium' }/>
            </div>,
            <div ref="nextButton"
                onClick={ () => (this.props.updateOnInteraction ? this.swiper.update() : null) }
                className={ classNames('swiper-button-next', useNativeScroll ? 'swiper-button__nativescroll' : null) }
                key='next'>
                <Icon symbol="productslider-right" size={ this.isCardSlider ? 'large' : 'medium' }/>
            </div>,
        ];
    }

    render() {
        const { children, facet, config, useNativeScroll } = this.props;

        return (
            <div
                className={ classNames(`slider slider__${ facet }`, (useNativeScroll ? 'slider__nativescroll-slider' : '')) }>
                <div ref="container" className="slider--container swiper-container">
                    <div className="slider--wrapper swiper-wrapper">
                        { looppa(children)((child, i) => (
                            <div key={ i } className="slider--slide swiper-slide">
                                { child }
                            </div>
                        )) }
                    </div>

                    { config.pagination ? <div className="slider--pagination swiper-pagination"></div> : '' }
                    { this.renderNavigationArrows() }
                </div>
            </div>
        );
    }
}

export default Slider;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/slider/index.js